export default {"src":"/_next/static/media/visual-desk.e5cae3bb.svg","height":241,"width":642,"blurWidth":0,"blurHeight":0};